const x = {
  /** 0px */
  none: 0,
  /** 2px */
  xxs: 0.5,
  /** 4px */
  xs: 1,
  /** 6px */
  sm: 1.5,
  /** 8px */
  md: 2,
  /** 10px */
  lg: 2.5,
  /** 12px */
  xl: 3,
  /** 16px */
  "2xl": 4,
  /** 20px */
  "3xl": 5,
  /** 24px */
  "4xl": 6,
  /** 9999px */
  full: "9999px"
};
export {
  x as r
};
